import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

const Metatags = ({
  pageTitle,
  metaTitle,
  description,
  keywords,
  imageUrl,
  type,
  datePublished,
  dateModified,
  schema,
  path = "/",
}) => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          keywords
          imageUrl
          author
          pageTitle
          metaTitle
        }
      }
    }
  `);

  const defaultDescription = data.site.siteMetadata.description;
  const defaultKeywords = data.site.siteMetadata.keywords;
  const defaultImageUrl = data.site.siteMetadata.imageUrl;
  const defaultPageTitle = data.site.siteMetadata.pageTitle;
  const defaultMetaTitle = data.site.siteMetadata.metaTitle;
  const author = data.site.siteMetadata.author;

  const pathname =
    typeof window !== "undefined" ? window.location.pathname : path;
  const siteUrl = `https://affordabledebtconsolidation.com${pathname}`;

  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": type || "WebPage",
      author: {
        "@type": "Person",
        name: author,
      },
      copyrightHolder: {
        "@type": "Person",
        name: author,
      },
      copyrightYear: new Date().getFullYear(),
      creator: {
        "@type": "Person",
        name: author,
      },
      publisher: {
        "@type": "Organization",
        name: author,
        logo: {
          "@type": "ImageObject",
          url: imageUrl || defaultImageUrl,
        },
      },
      datePublished: datePublished || new Date().toISOString(),
      dateModified: dateModified || new Date().toISOString(),
      description: description || defaultDescription,
      headline: pageTitle || defaultPageTitle,
      inLanguage: "en",
      url: siteUrl,
      name: pageTitle || defaultPageTitle,
      image: {
        "@type": "ImageObject",
        url: imageUrl || defaultImageUrl,
      },
      mainEntityOfPage: siteUrl,
    },
    schema,
  ];

  return (
    <React.Fragment>
      <title>{pageTitle || defaultPageTitle}</title>
      <meta name="title" content={metaTitle || defaultMetaTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="author" content={author} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="robots" content="max-image-preview:large" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="HandheldFriendly" content="true" />
      <meta name="theme-color" content="#ffffff" />
      <meta charSet="UTF-8" />
      <base href="/" />

      <link rel="canonical" href={siteUrl} />

      <meta property="og:image" content={imageUrl || defaultImageUrl} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={pageTitle || defaultPageTitle} />
      <meta property="og:type" content={type || "website"} />
      <meta property="og:site_name" content="Affordable Debt Consolidation" />
      <meta property="og:locale" content="en_US" />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta
        property="og:image:secure_url"
        content={imageUrl || defaultImageUrl}
      />

      <meta name="twitter:image" content={imageUrl || defaultImageUrl} />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={pageTitle || defaultPageTitle} />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      <meta
        name="google-site-verification"
        content="cAnVzQ-fJrBq4wW5M336NufUG97m9pClbw0N35lOh5U"
      />
      <link rel="alternate" hrefLang="en-US" href={siteUrl} />
      <script type="application/ld+json">
        {JSON.stringify(
          schemaOrgJSONLD
            .map((item) => (item ? item : null))
            .filter((item) => item !== null)
        )}
      </script>
    </React.Fragment>
  );
};

export default Metatags;
